// @flow
import { createReducer } from 'redux-act';
import * as actions from '../../actions/checksums';

export const initial_state = {
	is_pending: false,
	error: null,
	by_id: {},
};

export const checksum = createReducer({}, initial_state);

checksum.on(actions.fetchChecksums, state => ({
	...state,
	is_pending: true,
	error: null,
}));
checksum.on(actions.fetchChecksumsFailed, (state, payload) => ({
	...state,
	is_pending: false,
	error: payload,
}));
checksum.on(actions.fetchChecksumsSuccess, (state, payload) => ({
	...state,
	is_pending: false,
	error: null,
	by_id: payload,
}));


export default checksum;


// WEBPACK FOOTER //
// ./src/modules/reducers/checksums/index.js